export const DISCORD_LINK = 'https://discord.com/invite/FuvpNKwvQ4';
